import { useMemo } from 'react';
import { useAnswerCodes } from './useAnswerCodes';

export interface BackwaterValveLocation {
  backwater_valve_type_installed?: string;
}

interface BackwaterValveLogic {
  hasBackwaterValve: boolean;
}

export const useBackwaterValveLogic = (
  location: BackwaterValveLocation,
): BackwaterValveLogic => {
  const { getLabel } = useAnswerCodes();

  return useMemo(() => {
    const valveType = location?.backwater_valve_type_installed || '';

    if (!valveType) {
      return { hasBackwaterValve: false };
    }

    const label = getLabel(valveType, 'backwater_valve_type_installed');
    const isNone = label.toLowerCase() === 'none';

    return { hasBackwaterValve: !isNone };
  }, [location?.backwater_valve_type_installed, getLabel]);
};
